// extracted by mini-css-extract-plugin
module.exports = {"title":"content_title__1q7ya","root":"content_root__3P162","notice":"content_notice__1hOXZ","optionals":"content_optionals__30-lz"};